import { gql } from '@apollo/client'

export const updateCloudContent = gql`
  mutation UpdateCloudContent($_id: String!, $content: CloudContentInput!) {
    updateCloudContent(_id: $_id, content: $content)
  }
`
